import xhr from 'xhr'

export default async function getWelcomelist() {
  const res = await xhr(`/students/welcome/find`)
  return res.data
}
